/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Invalid_BodyInputs */

const en_invite_invalid_body = /** @type {(inputs: Invite_Invalid_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This invite has expired, was revoked or was already used. Ask for a new link.`)
};

const de_invite_invalid_body = /** @type {(inputs: Invite_Invalid_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Einladung ist abgelaufen, wurde zurückgezogen oder schon verwendet. Bitte um einen neuen Link.`)
};

/**
* | output |
* | --- |
* | "This invite has expired, was revoked or was already used. Ask for a new link." |
*
* @param {Invite_Invalid_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const invite_invalid_body = /** @type {((inputs?: Invite_Invalid_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Invalid_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_invite_invalid_body(inputs)
	return en_invite_invalid_body(inputs)
});